import {Component} from "./Component";

export class MobileConfig {

    components: [Component]


    public getConfigKeyByComponent(component_type, key) {


        for (let i = 0; i < this.components.length; i++) {

            if (this.components[i].type == component_type) {

                for (let k = 0; k < this.components[i].configurations.length; k++) {

                    if (this.components[i].configurations[k].key == key) {
                        return this.components[i].configurations[k].value;
                    }
                }

            }

        }


    }



}
